export type CanonicalPersonaId =
  | 'cheerleader'
  | 'listener'
  | 'active_advisor'
  | 'sleep_companion';

export const CANONICAL_PERSONA_ORDER: CanonicalPersonaId[] = [
  'cheerleader',
  'listener',
  'active_advisor',
  'sleep_companion',
];

const PERSONA_ALIAS_MAP: Record<string, CanonicalPersonaId> = {
  cheerleader: 'cheerleader',
  listener: 'listener',
  active_advisor: 'active_advisor',
  advisor: 'active_advisor',
  sleep_companion: 'sleep_companion',

  comfort: 'cheerleader',
  warm: 'listener',
  philosopher: 'active_advisor',
  roaster: 'sleep_companion',
};

const normalizeRawPersonaId = (id?: string | null): string =>
  (id || '')
    .trim()
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .replace(/[\s-]+/g, '_')
    .toLowerCase();

export const toCanonicalPersonaId = (
  id?: string | null,
  fallback: CanonicalPersonaId = 'listener',
): CanonicalPersonaId => {
  const normalized = normalizeRawPersonaId(id);
  return PERSONA_ALIAS_MAP[normalized] || fallback;
};

